// @ts-nocheck

import { createContext, useContext } from 'react';

type LineUpPlayerContextProps = {
  playerId?: number;
  competitorId?: number;
  isGoalKeeper?: boolean;
};

export const LineUpPlayerContext = createContext<LineUpPlayerContextProps>({});

export const useLineUpPlayerContext = () => useContext(LineUpPlayerContext);
